<bn-loading-overlay></bn-loading-overlay>
<div class="container col-md-9">

    <div class="row">
        <div class="col">
            <h3>
                Recuperações Inconsistentes
            </h3>
        </div>
        <div class="col-auto">
        </div>
    </div>
    <div class="row">
        <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="col nav-tabs">
            <li title="Recuperações após saldo com beneficiário liquidado" [ngbNavItem]>
                <a ngbNavLink>Recuperações após saldo com beneficiário liquidado</a>
                <ng-template ngbNavContent>
                    <div class="table-responsive">
                        <table class="table table-hover">
                            <app-recuperacao-credito-listagem
                                [recuperacoesCredito]="recIncAposSaldoComBeneficiarioLiquidado"
                                [atributosPaginacao]="atributosPaginacaoComponenteListagemAposSaldoComBeneficiarioLiquidado"
                                [ehAgenteFinanceiro]="false"
                                [mostrarExportarRecuperacoes]="false" 
                                [mostrarDatasValores]="false"
                                [mostrarFiltroPendencias]="true"
                                [estadoFiltroPendencias]="estadoFiltroPendencias"
                                [tipoPendencia]="'RECUPERACAO_APOS_SALDO_COM_BENEFICIARIO_LIQUIDADO'"
                                (aoMudarPagina)="mudancaPaginaRecIncAposSaldoComBeneficiarioLiquidado($event)"
                                (mudancaFiltroSomenteResolvidas)="mudancaSomenteResolvidasAposSaldoComBeneficiarioLiquidado($event)"
                                >
                            </app-recuperacao-credito-listagem>
                        </table>
                    </div>

                </ng-template>
            </li>

            <li title="Recuperações após cobrança encerrada informada" [ngbNavItem]>
                <a ngbNavLink>Recuperações após cobrança encerrada informada</a>
                <ng-template ngbNavContent>
                    <div class="table-responsive">
                        <table class="table table-hover">
                            <app-recuperacao-credito-listagem
                                [recuperacoesCredito]="recIncAposCobrancaEncerradaInformada"
                                [atributosPaginacao]="atributosPaginacaoComponenteListagemAposCobrancaEncerradaInformada"
                                [ehAgenteFinanceiro]="false"
                                [mostrarExportarRecuperacoes]="false"
                                [mostrarDatasValores]="false"
                                [mostrarFiltroPendencias]="true"
                                [estadoFiltroPendencias]="estadoFiltroPendencias"
                                [tipoPendencia]="'RECUPERACAO_APOS_COBRANCA_ENCERRADA_INFORMADA'"
                                (aoMudarPagina)="mudancaPaginaRecIncAposCobrancaEncerradaInformada($event)"
                                (mudancaFiltroSomenteResolvidas)="mudancaSomenteResolvidasAposCobrancaEncerradaInformada($event)"
                                >
                            </app-recuperacao-credito-listagem>
                        </table>
                    </div>

                </ng-template>
            </li>

            <li title="Recuperações após liquidação informada" [ngbNavItem]>
                <a ngbNavLink>Recuperações após liquidação informada</a>
                <ng-template ngbNavContent>
                    <div class="table-responsive">
                        <table class="table table-hover">
                            <app-recuperacao-credito-listagem
                                [recuperacoesCredito]="recIncAposLiquidacaoInformada"
                                [atributosPaginacao]="atributosPaginacaoComponenteListagemAposLiquidacaoInformada" 
                                [ehAgenteFinanceiro]="false"
                                [mostrarExportarRecuperacoes]="false" 
                                [mostrarDatasValores]="false"
                                [mostrarFiltroPendencias]="true"
                                [estadoFiltroPendencias]="estadoFiltroPendencias"
                                [tipoPendencia]="'RECUPERACAO_APOS_LIQUIDACAO_INFORMADA'"
                                (aoMudarPagina)="mudancaPaginaRecIncAposLiquidacaoInformada($event)"
                                (mudancaFiltroSomenteResolvidas)="mudancaSomenteResolvidasAposLiquidacaoInformada($event)"
                               >
                            </app-recuperacao-credito-listagem>
                        </table>
                    </div>

                </ng-template>
            </li>
        </ul>
        <div [ngbNavOutlet]="nav"></div>
    </div>

    <ng-template #carregando>
        <div class="loading-pesquisa">
            <i class="bn-loading"></i>
        </div>
    </ng-template>
</div>